var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-customer-view"},[(_vm.customer && _vm.customer.id)?_c('grid-details-component',{attrs:{"display_spec":_vm.customerProfileSpecs,"item":_vm.customer,"item_keys":_vm.customer_keys}}):_c('loader-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }